import React, { useContext } from 'react';
import LocalizationGroup from './components/LocalizationGroup/LocalizationGroup';
import { ILocalizationContext, LocalizationContext } from '../../../../localizationState/localizationContext';
import classNames from 'classnames';
import style from './InputFields.module.scss';

interface IInputFields {
	languageId: string;
	isVisible: boolean;
}

const InputFields: React.FC<IInputFields> = ({ languageId, isVisible }) => {
	const { groups } = useContext<ILocalizationContext>(LocalizationContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses}>
			{groups.map((el) => (
				<LocalizationGroup key={el.id} languageId={languageId} groupData={el} />
			))}
		</div>
	);
};

export default InputFields;
